const BASE_MEDIA_URL = process.env.REACT_APP_BASE_MEDIA_URL || "https://api.leaderbored.gg";

function getMediaUrl(path) {
  if (!path || !path.startsWith("/")) return null;

  return BASE_MEDIA_URL + path;
}

export default getMediaUrl;